import { WorkspaceEffects } from './workspace';

export const appEffects = [
  WorkspaceEffects,
];
